import EnhancedContentManifestRecord from "models/view-models/enhanced-content-manifest-record";
import ServiceFactory from "../service-factory";
import PublicationComponentType from "utilities/enumerations/publication-component-type";

// ---------------------------------------------------------------------------------------------
// #region Constants
// ---------------------------------------------------------------------------------------------

const baseEndpoint = "publications/:code/:edition/enhanced-content-manifests";

interface EnhancedContentBasePathParams {
    code: string;
    edition: string;
}

interface EnhancedContentQueryParams {
    nfpaLabel: string;
    publicationComponentType: PublicationComponentType;
}

// #endregion Constants

// ---------------------------------------------------------------------------------------------
// #region Service
// ---------------------------------------------------------------------------------------------
const EnhancedContentChapterManifestsService = {
    list: ServiceFactory.nestedList<
        EnhancedContentManifestRecord,
        EnhancedContentBasePathParams,
        EnhancedContentQueryParams
    >(EnhancedContentManifestRecord, baseEndpoint),
};

// #endregion Service

// ---------------------------------------------------------------------------------------------
// #region Exports
// ---------------------------------------------------------------------------------------------

export default EnhancedContentChapterManifestsService;

// #endregion Exports
